<ng-container *ngIf="abierto">
    <div class="backdrop"></div>
    <div class="modalPanelAdmin animated {{animacion}}">
        <div class="contenido">
            <div class="encabezadoModal">
                <div class="modalTituloSimple">{{'Búsqueda de preguntas'}}</div>
            </div>
            <div class="modalContenido">
                    <!-- título -->
                    <div class="row">
                        <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                            <inputCustom #inputpregunta
                              [titulo]="'Clave'"
                              [(ngModel)]="entidad.clave"
                              [disabled]="BlockPreguntaId"
                              [verError]="false"
                            ></inputCustom>
                          </div>
                          <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                            <inputCustom
                              [titulo]="'Pregunta'"
                              [(ngModel)]="entidad.pregunta"
                              [verError]="false"
                            ></inputCustom>
                          </div>
                        <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                            <dropdownCustom
                              [titulo]="'Competencia'"
                              [(ngModel)]="entidad.competenciaid"
                              [opciones]="SelCompetencia"
                              (ngModelChange)="SetCriterio($event)"
                              [valorName]="'competenciaid'"
                              [displayValor]="'nombre'"
                              [buscar]="false"
                            ></dropdownCustom>
                          </div>
                          <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                            <dropdownCustom
                              [titulo]="'Criterio'"
                              [(ngModel)]="entidad.criterioid"
                              [opciones]="SelCriterio"
                              [valorName]="'criterioid'"
                              [displayValor]="'nombre'"
                              [buscar]="false"
                            ></dropdownCustom>
                          </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                          <dropdownCustom
                            [titulo]="'Tipo de pregunta'"
                            [(ngModel)]="entidad.tipopreguntaid"
                            [opciones]="SelTipoPregunta"
                            [valorName]="'tipopreguntaid'"
                            [displayValor]="'nombre'"
                            (ngModelChange)="SetEscalaEvaluacion($event)"
                            [buscar]="false"
                          ></dropdownCustom>
                        </div>
                        <div class="col-lg-3 col-md-3 col-sm-12 col-12">
                          <dropdownCustom [titulo]="'Escala de evaluación'"
                              [(ngModel)]="entidad.escalaevaluacionid"
                              [buscar]="false"
                              [opciones]="SelEscalaevaluacion"
                              displayValor="nombre"
                              valorName="escalaevaluacionid"
                              propiedad="escalaevaluacionid"></dropdownCustom>
                      </div>
                          <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                            <dropdownCustom
                              [titulo]="'Nivel'"
                              [(ngModel)]="entidad.nivelid"
                              [multiSelect]="true"
                              [opciones]="SelNivel"
                              [valorName]="'nivelid'"
                              [disabled]="BlockNivel"
                              [displayValor]="'nombre'"
                              [buscar]="false"
                            ></dropdownCustom>
                          </div>
                      </div>
          
                      <!-- Botones de filtrado -->
                      <div class="row">
                        <div class="col-12">
                          <div class="panelBotonesFiltro">
                            <button
                              class="boton botonSM filledBlanco"
                              (click)="LimpiarFiltros()"
                            >
                              {{'Limpiar' | translate}}
                            </button>
          
                            <div class="divisorH16"></div>
          
                            <button class="boton botonSM filled" (click)="buscar()">
                              {{'Consultar' | translate}}
                            </button>
                          </div>
                        </div>
                      </div>
                      
                      <div class="divisorgris"></div>
                      <div class="divisor16"></div>

                    <div>
                      <h5>{{texto}}</h5>
                    <!-- datos -->
                    <dx-data-grid
                    #grid
                    (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
                    id="tabla"
                    [columnAutoWidth]="true"
                    [dataSource]="dataTable"
                    keyExpr="preguntaid"
                    [noDataText]="'Sin Datos'"
                    [(selectedRowKeys)]="preguntasimportar"
                    [showColumnHeaders]="true"
                    >
                    <dxo-search-panel
                        [visible]="true"
                        [width]="240"
                        placeholder="{{'Buscar' | translate}}">
                    </dxo-search-panel>
        
        
                    <dxo-paging [pageSize]="sistemaService.tablaPaginacion"></dxo-paging>
        
                    <dxo-pager
                        [visible]="true"
                        [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
                        [displayMode]="sistemaService.tablaPaginacionModo"
                        [showPageSizeSelector]="sistemaService.tablaPaginacionSelector"
                        [showInfo]="sistemaService.tablaPaginacionInfo"
                        [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion">
                    </dxo-pager>

                    <dxo-selection
                            [selectAllMode]="'allPages'"
                            [showCheckBoxesMode]="'always'"
                            mode="multiple"
                          ></dxo-selection>
                    <dxi-column
                        dataField="competencia"
                        caption="Competencia">
                    </dxi-column>
                    <dxi-column
                        dataField="criterio"
                        caption="Criterio">
                    </dxi-column>
                    <dxi-column
                        dataField="pregunta"
                        caption="Pregunta">
                    </dxi-column>
                    <dxi-column
                        dataField="tipopregunta"
                        caption="Tipo de pregunta">
                    </dxi-column>
                    <dxi-column
                        dataField="nivel"
                        caption="Nivel">
                    </dxi-column>
                    <dxi-column
                        dataField="clave"
                        caption="Clave">
                    </dxi-column>
                </dx-data-grid>
                    </div>
            </div>
                  <!-- footer -->
      <div class="modalFooter">
        <div class="contenidoFooter botonesIzq">
          <!-- editar -->
          <div class="botonDerecha">
            <button class="boton botonSM filledBlanco" (click)="CerrarModal()">
              Cancelar
            </button>
            <div class="divisorH16"></div>
            <button class="boton botonSM filled" (click)="Guardar()">
              Guardar
            </button>
          </div>
        </div>
      </div>
        </div>
    </div>
</ng-container>
